<template lang="pug">
.dashBoard
  .s1(v-if='columns.column7.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"professiy"', size='superLarge')
    .hint
      p.root {{ columns.column7.count }}
      p.bottom ПРОФЕССИЙ
  .s2(v-if='columns.column3.count !== 0')
    AppSvgIcon.svgIcon(
      :icon-name='"obrazovatelOrganizatsiy"',
      size='superLarge'
    )
    .hint
      p.root {{ columns.column3.count }}
      p.bottom ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ
  .s3(v-if='columns.column5.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"rabotodateley"', size='superLarge')
    .hint
      p.root {{ columns.column5.count }}
      p.bottom РАБОТОДАТЕЛЕЙ
  .s4(v-if='columns.column1.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"expert"', size='superLarge')
    .hint
      p.root {{ columns.column1.count }}
      p.bottom ОБРАТИВШИХСЯ В ЦОПП
  .s5(v-if='columns.column9.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"teacher"', size='superLarge')
    .hint
      p.root {{ columns.column9.count }}
      p.bottom ПРЕПОДАВАТЕЛЕЙ
  .s6(v-if='columns.column8.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"kompetentsiy"', size='superLarge')
    .hint
      p.root {{ columns.column8.count }}
      p.bottom КОМПЕТЕНЦИЙ
  .s7(v-if='columns.column4.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"obrazovatelProgramm"', size='superLarge')
    .hint
      p.root {{ columns.column4.count }}
      p.bottom ОБРАЗОВАТЕЛЬНЫХ ПРОГРАММ
  .s8(v-if='columns.column6.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"vakansiy"', size='superLarge')
    .hint
      p.root {{ columns.column6.count }}
      p.bottom ВАКАНСИЙ
  .s9(v-if='columns.column2.count !== 0')
    AppSvgIcon.svgIcon(
      :icon-name='"okonchivshikhObucheniye"',
      size='superLarge'
    )
    .hint
      p.root {{ columns.column2.count }}
      p.bottom ОКОНЧИВШИХ ОБУЧЕНИЕ
  .s10(v-if='columns.column10.count !== 0')
    AppSvgIcon.svgIcon(:icon-name='"obrativshikhsya"', size='superLarge')
    .hint
      p.root {{ columns.column10.count }}
      p.bottom ЭКСПЕРТОВ ВСР
</template>

<script>
import AppSvgIcon from '../../../uikit/components/AppSvgIcon/AppSvgIcon';
export default {
  name: 'dashboard',
  components: { AppSvgIcon },
  inject: ['$api'],
  data() {
    return {
      columns: {
        column1: {
          count: 0,
        },
        column2: {
          count: 0,
        },
        column3: {
          count: 0,
        },
        column4: {
          count: 0,
        },
        column5: {
          count: 0,
        },
        column6: {
          count: 0,
        },
        column7: {
          count: 0,
        },
        column8: {
          count: 0,
        },
        column9: {
          count: 0,
        },
        column10: {
          count: 0,
        },
      },
    };
  },
  async mounted() {
    let {
      data: { data },
    } = await this.$api.get('metrics/performance-indicators');
    data.forEach((elem) => {
      if (this.columns[elem.id]) {
        this.columns[elem.id].count = elem.count;
      }
    });
  },
};
</script>

<style scoped lang="stylus">
@import '~@/stylus/helpers/mediaqueriesStep'
.svgIcon
  color white
.dashBoard > *
  display: flex;
  justify-content: flex-start;
  flex-direction column
  align-items center
  .hint
    color #171e4b
    padding-top: 5px;
    .root
      text-align center
      font-weight bold
      font-size: 26px;
    .bottom
      text-align center
.dashBoard
  display grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  //grid-template-areas: "s1 s2 s3 s4 s5" "s6 s7 s8 s9 s10"
  gap: 10px 10px;
  +phone()
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    //grid-template-areas: "s1 s2 s3" "s4 s5 s6" "s7 s8 s9" "s11 s10 s12"
</style>



// WEBPACK FOOTER //
// dashboard.vue?89ff084e